import { Grid as StyledGrid } from './Grid.styles';

const Grid = {
	Row: StyledGrid.Row,
	Column: StyledGrid.Column
};

export default Grid;
